import React from "react";
import "./BillSelectTip.css";
import BillTipPercent from "./BillTipPercent";

export default function BillSelectTip(props) {
  const tipValues = [
    {
      className: "tip-percent-container__box",

      value: 5,
    },
    {
      className: "tip-percent-container__box",

      value: 10,
    },
    {
      className: "tip-percent-container__box",

      value: 15,
    },
    {
      className: "tip-percent-container__box",

      value: 25,
    },
    {
      className: "tip-percent-container__box",

      value: 50,
    },
  ];
  return (
    <div>
      <h3 className="label">Select Tip %</h3>
      <div className="tip-percent-container">
        {tipValues.map((tip) => (
          <BillTipPercent
            key={tip.value}
            onSelectTip={props.onSelectTip}
            tipClassName={tip.className}
            tipValue={tip.value}
          />
        ))}
        <div className="custom">
          <input
            onChange={(e) => props.onSelectTip(e.target.value)}
            className="tip-percent-container__box"
            type="number"
            min="0"
            value={props.tipAmount}
          />
        </div>
      </div>
    </div>
  );
}
